import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalProps } from '@context/ModalsContext'

import { Link } from '@ui/components/Link'
import { Modal } from '@ui/components/Modal'

export const BrowserOutdatedModal: React.FC<BaseModalProps> = (props) => {
  const { close } = props

  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Your browser is outdated')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('You seem to be using an outdated browser')} {'('}
          <Link href='https://play.google.com/store/apps/details?id=com.tickmill&pli=1'>
            Android
          </Link>
          {' /'}
          <Link href='https://apps.apple.com/app/tickmill/id1548644102'>iOS</Link>
          {')'}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
